import React from "react";
import { Menu, Dropdown, DropdownMenu, DropdownItem } from "semantic-ui-react";
import { PropTypes } from "prop-types";

const DocumentationMenuItems = ({
  selectedItem,
  handleItemClick,
  isMobile,
}) => {
  const dropdownStyle = isMobile
    ? {
        position: "absolute",
        top: "100%",
        left: "0",
        zIndex: 1,
        backgroundColor: "white",
        boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
      }
    : {};

  return (
    <>
      <Menu.Item
        name="main"
        active={selectedItem === "main"}
        onClick={handleItemClick}
      >
        Home
      </Menu.Item>
      <Menu.Item
        name="user_search"
        active={selectedItem === "user_search"}
        onClick={handleItemClick}
      >
        User search
      </Menu.Item>
      <Menu.Item
        name="api_usage"
        active={selectedItem === "api_usage"}
        onClick={handleItemClick}
      >
        How to use the API tokens
      </Menu.Item>
      <Menu.Item
        active={[
          "creation",
          "record_detail",
          "record_update",
          "record_delete",
          "files",
          "publication",
          "quality_checks",
          "search",
        ].includes(selectedItem)}
        style={{ padding: 0 }}
      >
        <Dropdown
          item
          text="Api Documentation"
          style={isMobile ? { position: "relative" } : {}}
        >
          <DropdownMenu style={dropdownStyle}>
            {[
              "creation",
              "record_detail",
              "record_update",
              "record_delete",
              "files",
              "publication",
              "quality_checks",
              "search",
            ].map((name) => (
              <DropdownItem
                key={name}
                text={name.replace("_", " ")}
                name={name}
                onClick={handleItemClick}
              />
            ))}
          </DropdownMenu>
        </Dropdown>
      </Menu.Item>
      <Menu.Item
        name="json_create_example"
        active={selectedItem === "json_create_example"}
        onClick={handleItemClick}
      >
        JSON Create example
      </Menu.Item>
      <Menu.Item
        active={["datasets", "external_datasets"].includes(selectedItem)}
        style={{ padding: 0 }}
      >
        <Dropdown
          item
          text="Metadata models"
          style={isMobile ? { position: "relative" } : {}}
        >
          <DropdownMenu style={dropdownStyle}>
            {["datasets", "external_datasets"].map((name) => (
              <DropdownItem
                key={name}
                text={name.replace("_", " ")}
                name={name}
                onClick={handleItemClick}
              />
            ))}
          </DropdownMenu>
        </Dropdown>
      </Menu.Item>
      <Menu.Item
        name="permission_table"
        active={selectedItem === "permission_table"}
        onClick={handleItemClick}
      >
        Permission table
      </Menu.Item>
      <Menu.Item
        name="dar_invenio_cli"
        active={selectedItem === "dar_invenio_cli"}
        onClick={handleItemClick}
      >
        DAR Invenio CLI
      </Menu.Item>
    </>
  );
};

DocumentationMenuItems.propTypes = {
  selectedItem: PropTypes.string.isRequired,
  handleItemClick: PropTypes.func.isRequired,
  isMobile: PropTypes.bool,
};

DocumentationMenuItems.defaultProps = {
  isMobile: false,
};

export default DocumentationMenuItems;
